
function Footer() {
    return (
        <>
      
      <footer class="bg-light text-center text-lg-start" style={{marginTop: -30}}>
 
 <div class="text-center p-3" style={{backgroundColor: "#347C2C", color: 'white'}}>
   © 2021 Copyright:
   <a class="text-light" href="https://mdbootstrap.com/"> Empower Nigerians</a>
 </div>

</footer>
  
 
  </>
    );
  }

  export default Footer